<!-- <div class="container"> -->
    <div fxFlex=100 fxFlex.lt-md=100 >
        <div >
            <div class="urlDiv" fxLayout="row wrap">
                <a class="urls" href="/userProfiles/{{userId}}?home=false">
                  Home /
                </a>
                <a  class="urls" href="/hitmaker">
                   &nbsp;Hitmaker /
                </a>
                <a  class="urls" href="/hitmaker/{{movieId}}">
                    &nbsp;{{movieName}}
                 </a>
                </div>
 <div class="videoInfo" fxLayout="row wrap" fxLayoutAlign="center" fxLayout.lt-md="column"
                fxLayoutAlign.lt-md="center center">
        <div class="movieDesc" fxLayout="column">
            <h2 style="text-align: center;
            background-color: #6fc2d2;
            color: white;
            font-size: 30px;
            margin-top: 20px;
            margin-bottom: 10px;
            font-weight: 400;
            font-family: 'Lato';">{{movieName}} </h2>            
            <div class="movieDesc_scrollable">
              
                    <div class="column" fxLayout="row wrap">
                    <p class="descriptionText" style="display:inline-block">
                        <strong style="font-weight: 600; font-family: 'Lato';">Film Description:</strong>
                        {{movieDesc}}
                    </p>
                </div>
            </div>
        </div>
    
        <div class="movieBanner" fxLayout="column">
            <img class="imgMovie" [src]="movieBannerImg">
        </div>
        
        <div class="row" id="textDiv" fxLayout="column">
            <h2 class="textDiscover" id="discover1">Discover and engage with this movie and artists below.
            </h2>
    
            <h1 class="discover" style="justify-content: center !important;font-weight: 500;" >Film Stages
            </h1>
        </div>
    
        <div class="flexBox"  fxFlex="100%" fxFlex.md="90%"  fxLayout.lt-md="50%" fxLayout="row wrap" fxLayoutAlign="center center" fxLayout.lt-md="column" >
    
            <div class="card" fxFlex="15%" fxFlex.md="20%" fxFlex.lt-md="30%">
               
                <div class="card-text-div">
                    <a class="card-text" href=""  style="text-decoration: none;" (click)="getStageDetails('casting', $event)" >
                        <span style="color: white;font-size: 18px;
                        padding-left: 10px;
                        padding-right: 10px;">Casting</span>
                        <br>
                        <span style="color: white;font-size: 14px;
                        text-align: center;">Help discover the next great<br> movie star!</span>
                    </a>
                </div>
                <div class="card-img-div" (click)="getStageDetails('casting', $event)" >
                    <a href="">
                       <img class="card-content" height="80%" width="100%" [src]="showCastingThumbnailValue ? stage1Image : '/../../../../../../assets/images/hitmaker/1_Casting.jpg'">
                       <span class="numberCircle">1</span>                       

                    </a> 
                </div>
            </div>
    
            <div class="card" fxFlex="15%" fxFlex.md="20%" fxFlex.lt-md="30%">
                <div class="card-text-div">
                    <a class="card-text"  href="" (click)="getStageDetails('pre-production', $event)" style="text-decoration: none;">
                        <span  style="color: white;font-size: 18px;
                        padding-left: 10px;
                        padding-right: 10px;">Pre-Production</span>
                        <br>
                        <span  style="color: white;font-size: 14px;text-align: center;">
                            Enjoy a show on your star’s<br> journey!</span>
                    </a>
                </div>
                <div class="card-img-div" (click)="getStageDetails('pre-production', $event)">
                    
                        <a href="">
                            <img class="card-content" height="80%"  [src]="showPreProductionThumbnailValue ? stage2Image : '/../../../../../../assets/images/hitmaker/2_PreProduction.jpg'" width="100%">
                            <span class="numberCircle">2</span>                       

                        </a>

                        
                </div>
            </div>
    
            <div class="card" fxFlex="15%" fxFlex.md="20%" fxFlex.lt-md="30%">
                <div class="card-text-div">
                    <a class="card-text" href=""  (click)="getStageDetails('filming', $event)" style="text-decoration: none;">
                        <span style="color: white;font-size: 18px;
                        padding-left: 10px;
                        padding-right: 10px;">Filming</span>
                        <br>
                        <span style="color: white;font-size: 14px;
                        text-align: center;">  Enter the exciting  world of  film<br> production!</span>
                    </a>
                </div>
                <div class="card-img-div"  (click)="getStageDetails('filming', $event)">
                    
                        <a href="">
                            <img class="card-content" height="80%" [src]="showFilmingThumbnailValue ? stage3Image : '/../../../../../../assets/images/hitmaker/3_Filming.jpg'" width="100%">
                            <span class="numberCircle">3</span>                       

                        </a>
                         
                </div>
            </div>
    
            <div class="card" fxFlex="15%" fxFlex.md="20%" fxFlex.lt-md="30%">
                <div class="card-text-div">
                    <a class="card-text" href=""  (click)="getStageDetails('post-production', $event)" style="text-decoration: none;">
                        <span style="color: white;font-size: 18px;
                        padding-left: 10px;
                        padding-right: 10px;">Post-Production</span>
                        <br>
                        <span style="color: white;font-size: 14px;
                        padding-left: 10px;
                        padding-right: 10px;">Help  pick the film score and <br> more !</span>
                    </a>
                </div>
                <div class="card-img-div" (click)="getStageDetails('post-production', $event)">
                    
                        <a href="">
                            <img class="card-content" height="80%" [src]="showPostProductionThumbnailValue ? stage4Image : '/../../../../../../assets/images/hitmaker/4_PostProduction.jpg'" width="100%">
                            <span class="numberCircle">4</span>                       

                        </a>
                        
                </div>
            </div>
    
            <div class="card" fxFlex="15%" fxFlex.md="20%" fxFlex.lt-md="30%">
                <div class="card-text-div">
                    <a class="card-text" href=""  (click)="getStageDetails('release', $event)" style="text-decoration: none;">
                        <span  style="color: white;font-size: 18px;
                        padding-left: 10px;
                        padding-right: 10px;">Release</span>
                        <br>
                        <span  style="color: white;font-size: 14px;
                        padding-left: 10px;
                        padding-right: 10px;">culiminate the journey with<br> special access!</span>
                    </a>
                </div>
                <div class="card-img-div"  (click)="getStageDetails('release', $event)">
                    
                        <a href="">
                            <img class="card-content" height="80%" [src]="showReleaseThumbnailValue ? stage5Image : '/../../../../../../assets/images/hitmaker/5_Release.jpg'" width="100%">
                            <span class="numberCircle">5</span>                       

                        </a>
                        
                </div>
            </div>
            
        </div>
    </div>
    

  
</div>
<!-- <div class="mobile-view">
    <div class="urlDiv" fxLayout="row wrap">
        <a class="urls" href="/userProfiles/{{userId}}?home=false">
          Home /
        </a>
        <a  class="urls" href="/hitmaker">
           &nbsp;Hitmaker /
        </a>
        <a  class="urls" href="/hitmaker/{{movieName}}">
            &nbsp;{{movieName}}
         </a>
        </div>
    <div class="wrap">
        <div class="movieDesc">
            <h2 style="text-align: center;
            background-color: #6fc2d2;
            color: white;
            font-size: 30px;
            margin-top: 20px;
            margin-bottom: 10px;
            font-weight: 400;
            font-family: lato;">{{movieName}} </h2>
            
            <div class="movieDesc_scrollable">
                <p style="text-align: justify;">
                    <strong style="font-weight: 500;">Film Description:</strong>
                    <br>
                    </p>
                    <div class="column" fxLayout="row wrap">
                    <p class="descriptionText" style="display:inline-block">
                        {{movieDesc}}
                    </p>
                </div>
            </div>
        </div>
    
        <div class="movieBanner">
            <img class="img-fluid" [src]="movieBannerImg">
        </div>

        <div class="row" fxLayout="row wrap">
            <h2 class="textDiscover"  fxLayout="row wrap">Discover and engage with this movie and artists below.
            </h2>
    
            <h1 class="discover" fxLayout="row wrap"  >Film Stages
            </h1>
        </div>
    
        <div class="flexBox"   fxLayout="row wrap">
    
            <div class="card">
               
                <div class="card-text-div">
                    <a class="card-text" href=""  style="text-decoration: none;" (click)="getStageDetails('casting', $event)" >
                        <span style="color: white;font-size: 18px;font-family: 'Lato';
                        padding-left: 10px;
                        padding-right: 10px;">Casting</span>
                        <br>
                        <span style="color: white;font-size: 14px;font-family: 'Lato';
                        text-align: center;">Help discover the next great<br> movie star!</span>
                    </a>
                </div>
                <div class="card-img-div" (click)="getStageDetails('casting', $event)" >
                    <a href="">
                       <img class="card-content" height="80%" width="100%" [src]="showCastingThumbnailValue ? stage1Image : '/../../../../../../assets/images/hitmaker/1_Casting.jpg'">
                       <span class="numberCircleMob">1</span>                       

                    </a>                        
                </div>
            </div>
    
            <div class="card">
                <div class="card-text-div">
                    <a class="card-text"  href="" (click)="getStageDetails('pre-production', $event)" style="text-decoration: none;">
                        <span  style="color: white;font-size: 18px;font-family: 'Lato';
                        padding-left: 10px;
                        padding-right: 10px;">Pre-Production</span>
                        <br>
                        <span  style="color: white;font-size: 14px;text-align: center;font-family: 'Lato';">
                            Enjoy a show on your star’s<br> journey!</span>
                    </a>
                </div>
                <div class="card-img-div" (click)="getStageDetails('pre-production', $event)">
                    
                        <a href="">
                            <img class="card-content" height="80%"  [src]="showPreProductionThumbnailValue ? stage2Image : '/../../../../../../assets/images/hitmaker/2_PreProduction.jpg'" width="100%">
                            <span class="numberCircleMob">2</span>                       

                        </a>

                        
                </div>
            </div>
    
            <div class="card" >
                <div class="card-text-div">
                    <a class="card-text" href=""  (click)="getStageDetails('filming', $event)" style="text-decoration: none;">
                        <span style="color: white;font-size: 18px;font-family: 'Lato';
                        padding-left: 10px;
                        padding-right: 10px;">Filming</span>
                        <br>
                        <span style="color: white;font-size: 14px;font-family: 'Lato';
                        text-align: center;">  Enter the exciting  world of  film<br> production!</span>
                    </a>
                </div>
                <div class="card-img-div"  (click)="getStageDetails('filming', $event)">
                    
                        <a href="">
                            <img class="card-content" height="80%" [src]="showFilmingThumbnailValue ? stage3Image : '/../../../../../../assets/images/hitmaker/3_Filming.jpg'" width="100%">
                            <span class="numberCircleMob">3</span>                       

                        </a>
                         
                </div>
            </div>
    
            <div class="card">
                <div class="card-text-div">
                    <a class="card-text" href=""  (click)="getStageDetails('post-production', $event)" style="text-decoration: none;">
                        <span style="color: white;font-size: 18px;font-family: 'Lato';
                        padding-left: 10px;
                        padding-right: 10px;">Post-Production</span>
                        <br>
                        <span style="color: white;font-size: 14px;font-family: 'Lato';
                        padding-left: 10px;
                        padding-right: 10px;">Help  pick the film score and <br> more !</span>
                    </a>
                </div>
                <div class="card-img-div" (click)="getStageDetails('post-production', $event)">
                    
                        <a href="">
                            <img class="card-content" height="80%" [src]="showPostProductionThumbnailValue ? stage4Image : '/../../../../../../assets/images/hitmaker/4_PostProduction.jpg'" width="100%">
                            <span class="numberCircleMob">4</span>                       

                        </a>
                        
                </div>
            </div>
    
            <div class="card">
                <div class="card-text-div">
                    <a class="card-text" href=""  (click)="getStageDetails('release', $event)" style="text-decoration: none;">
                        <span  style="color: white;font-size: 18px;font-family: 'Lato';
                        padding-left: 10px;
                        padding-right: 10px;">Release</span>
                        <br>
                        <span  style="color: white;font-size: 14px;font-family: 'Lato';
                        padding-left: 10px;
                        padding-right: 10px;">culiminate the journey with<br> special access!</span>
                    </a>
                </div>
                <div class="card-img-div"  (click)="getStageDetails('release', $event)">
                    
                        <a href="">
                            <img class="card-content" height="80%" [src]="showReleaseThumbnailValue ? stage5Image : '/../../../../../../assets/images/hitmaker/5_Release.jpg'" width="100%">
                            <span class="numberCircleMob">5</span>                       

                        </a>
                        
                </div>
            </div>
    
        </div>
    
    </div>

  
</div> -->
</div>
<!-- </div> -->

